<template>
  <Chart
    :size="{ width: width, height: height }"
    :data="plotDataVals"
    :margin="margin"
    :direction="direction"
    :axis="axis"
    class="text-sm text-gray-over-dark"
  >
    <template #layers>
      <!-- <Grid strokeDasharray="2,2" /> -->

      <g>
        <Area
          :data-keys="['nameTop', 'plTop']"
          type="monotone"
          :fill-opacity="1"
          class="path-opacity-1"
          :area-style="{ fill: 'url(#grad2)' }"
        />
        <Area
          :data-keys="['nameT', 'plT']"
          type="monotone"
          :fill-opacity="1"
          class="path-opacity-1"
          :area-style="{ fill: 'url(#gradWhite)' }"
        />
        <Area
          :data-keys="['nameB', 'plB']"
          type="monotone"
          :fill-opacity="1"
          class="path-opacity-1"
          :area-style="{ fill: 'url(#grad)' }"
        />
      </g>

      <!-- <Line
        :dataKeys="['name', 'pl']"
        type="monotone"
        :lineStyle="{
          stroke: '#f8c617'
        }"
        :dotStyle="{
          stroke: '#ffffff',
          r: 12,
          strokeWidth: 12
        }"
      /> -->
      <Line
        :data-keys="['nameB', 'plB']"
        type="monotone"
        :line-style="{
          stroke: '#ef4444',
          strokeWidth: 4,
        }"
        :hide-dot="true"
        :dot-style="{
          stroke: '#ef4444',
          r: 1,
          strokeWidth: 2,
        }"
      />
      <Line
        :data-keys="['name', 'pl']"
        type="monotone"
        :line-style="{
          stroke: '#f8c617',
          strokeWidth: 4,
        }"
        :hide-dot="true"
        :dot-style="{
          stroke: '#f8c617',
          r: 1,
          strokeWidth: 2,
        }"
      />

      <Line
        :data-keys="['nameT', 'plT']"
        type="monotone"
        :line-style="{
          stroke: '#54c774',
          strokeWidth: 4,
        }"
        :hide-dot="true"
        :dot-style="{
          stroke: '#54c774',
          r: 1,
          strokeWidth: 2,
        }"
      />
      <Line
        :data-keys="['nameTop', 'plTop']"
        type="monotone"
        :line-style="{
          stroke: '#54c774',
          strokeWidth: 0,
        }"
        :hide-dot="true"
        :dot-style="{
          stroke: '#54c774',
          r: 1,
          strokeWidth: 2,
        }"
      />

      <!-- <Labels :dataKeys="['name', 'pl']" /> -->
      <LabelsInsights
        color="#dfb215"
        :ypos="-60"
        :xpos="0"
        xalign="middle"
        :data-keys="['name3', 'pl3', 'msg']"
      />
      <LabelsInsights
        color="#ef4444"
        :ypos="-30"
        :xpos="0"
        xalign="middle"
        :data-keys="['name2', 'pl2', 'msg']"
      />
      <LabelsInsights
        color="#54c774"
        :ypos="-30"
        :hide-pulse-dot="false"
        :xpos="0"
        xalign="middle"
        :data-keys="['nameTLabel', 'plTLabel', 'msgTLabel']"
      />
      <LabelsInsights
        color="#ef4444"
        :ypos="-30"
        :hide-pulse-dot="false"
        :wider="true"
        :xpos="0"
        xalign="middle"
        :data-keys="['nameBLabel', 'plBLabel', 'msgBLabel']"
      />
      <Line
        :data-keys="['name3', 'pl3']"
        type="monotone"
        :line-style="{
          stroke: '#ffffff',
        }"
        :dot-style="{
          stroke: '#dfb215',
          r: 8,
          strokeWidth: 6,
        }"
      />
      <Line
        :data-keys="['name2', 'pl2']"
        type="monotone"
        :line-style="{
          stroke: '#ffffff',
        }"
        :dot-style="{
          stroke: '#ef4444',
          r: 8,
          strokeWidth: 6,
        }"
      />

      <!-- <LabelsInsights :dataKeys="['name2', 'pl2', 'msg']" /> -->
      <!-- <Labels :dataKeys="['name', 'pl']" /> -->
      <Marker
        v-if="marker"
        :value="0"
        style="font-size: 12px"
        color="#ef4444"
        :stroke-width="strokeWidth"
        stroke-dasharray="0 0"
      />
      <!-- <Marker v-if="marker" :value="bottom10Pct" style="font-size: 12px;" label="Bottom 10% of carriers" color="#A9ADBD" :strokeWidth="strokeWidth" strokeDasharray="12 12" /> -->
      <defs>
        <!-- <linearGradient id="grad" gradientTransform="rotate(90)">
          <stop offset="0%" stop-color="#db3713" stop-opacity="0.2" />
          <stop offset="1%" stop-color="#db3713" stop-opacity="1" />
        </linearGradient> -->
        <!-- <linearGradient id="grad" x1="0%" y1="0%" x2="10%" y2="20%">
          <stop offset="0%" style="stop-color:#db3713;stop-opacity:0" />
          <stop offset="10%" style="stop-color:#db3713;stop-opacity:1" />
          <stop offset="10%" style="stop-color:#db3713;stop-opacity:1" />
          <stop offset="10%" style="stop-color:#db3713;stop-opacity:1" />
          <stop offset="10%" style="stop-color:#db3713;stop-opacity:1" />
          <stop offset="10%" style="stop-color:#db3713;stop-opacity:1" />
          <stop offset="90%" style="stop-color:#db3713;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#db3713;stop-opacity:1" />
        </linearGradient> -->
        <!-- <linearGradient id="grad" x1="-14.9%" y1="20.31%" x2="41%" y2="10%" data-v-507fc168=""><stop offset="0%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop><stop offset="0.29%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop><stop offset="0.39%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 0;"></stop><stop offset="0.54%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop><stop offset="1.56%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop><stop offset="1.5%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop><stop offset="90%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop><stop offset="100%" data-v-507fc168="" style="stop-color: rgb(219, 55, 19); stop-opacity: 1;"></stop></linearGradient> -->
        <linearGradient
          id="grad"
          x1="0%"
          y1="20%"
          x2="45%"
          y2="86%"
        >
          <stop
            offset="60%"
            style="stop-color: #db3713; stop-opacity: 0"
          />
          <stop
            offset="92%"
            style="stop-color: #db3713; stop-opacity: 0.2"
          />
          <stop
            offset="100%"
            style="stop-color: #db3713; stop-opacity: 0.25"
          />
        </linearGradient>
        <linearGradient
          id="grad2"
          x1="-20%"
          y1="10%"
          x2="50%"
          y2="80%"
        >
          <stop
            offset="30%"
            style="stop-color: #54c774; stop-opacity: 1"
          />
          <stop
            offset="60%"
            style="stop-color: #54c774; stop-opacity: 0.3"
          />
          <stop
            offset="80%"
            style="stop-color: #54c774; stop-opacity: 0"
          />
        </linearGradient>
        <linearGradient
          id="gradWhite"
          gradientTransform="rotate(90)"
        >
          <stop
            offset="0%"
            stop-color="#ffffff"
            stop-opacity="1"
          />
          <stop
            offset="100%"
            stop-color="#ffffff"
            stop-opacity="1"
          />
        </linearGradient>
      </defs>
    </template>

    <template #widgets>
      <!-- <Tooltip
        borderColor="#48CAE4"
        :config="{
          pl: { color: '#9f7aea' },
        }"
      /> -->
    </template>
  </Chart>
</template>

<script lang="ts">
// import { defineComponent,  ref, toRefs } from 'vue'
import { defineComponent, ref } from 'vue';
// import { Chart, Grid, Line, Marker, Area, usePoints } from 'vue3-charts'
import { Chart, Line, Marker, Area } from 'vue3-charts';
// import Labels from '@/components/Labels.vue'
import LabelsInsights from './LabelsInsights.vue';

export default defineComponent({
  name: 'LineChartInsights',
  // components: { Chart, Grid, Line, Marker, Area, Labels },
  components: { Chart, Line, Marker, Area, LabelsInsights },
  props: {
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    plotData: {
      type: Array,
      required: true,
    },
    top10Pct: {
      type: Number,
      required: false,
    },
    bottom10Pct: {
      type: Number,
      required: false,
    },
    dataMaximumX: {
      type: Number,
      required: true,
    },
    dataMaximumY: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    // var plByMonth = [
    //   { name: 'Jan', pl: 1000, avg: 500, inc: 300 },
    //   { name: 'Feb', pl: 2000, avg: 900, inc: 400 },
    //   { name: 'Apr', pl: 400, avg: 400, inc: 500 },
    //   { name: 'Mar', pl: 3100, avg: 1300, inc: 700 },
    //   { name: 'May', pl: 200, avg: 100, inc: 200 },
    //   { name: 'Jun', pl: 600, avg: 400, inc: 300 },
    //   { name: 'Jul', pl: 500, avg: 90, inc: 100 }
    // ]
    // const data = ref(plByMonth);
    // const width = ref(width)
    // const height = ref(height)
    // const plotData = ref(plotData)
    // const top10Pct = ref(top10Pct)
    // const bottom10Pct = ref(bottom10Pct)
    // const dataMaximumX = computed(() => (props.dataMaximumX).toString());
    // const dataMaximumY = computed(() => (props.dataMaximumY).toString());
    // const dataMinimumY = computed(() => ((props.dataMaximumY * -0.1).toFixed(2)).toString());
    const dataMaximumX = ref(props.dataMaximumX.toString());
    const dataMaximumY = ref(props.dataMaximumY.toString());
    const dataMinimumY = ref((props.dataMaximumY * 0).toFixed(2).toString());
    const dataLength = ref(props.plotData?.length);
    const plotDataVals = ref(props.plotData);

    // const dataMaximum = ref(props.dataMaximumValue)
    const direction = ref('horizontal');
    const margin = ref({
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    });

    const marker = true;
    const strokeWidth = 1;

    const axis = ref({
      primary: {
        domain: ['dataMin', 'dataMax + 2'],
        type: 'linear',
        ticks: dataLength.value,
      },
      secondary: {
        domain: ['dataMin - 60', 'dataMax + 70'],
        // domain: [ bottom10Pct * 0.8, top10Pct * 1.1 ],
        type: 'linear',
        ticks: 6,
      },
    });

    // const maxX = toRef(props.dataMaxima, 'xVal');
    // const maxX = ref(props.dataMaxima.x);
    // const maxY = ref(props.dataMaxima.y);
    // console.log('props.dataMaxima = '+JSON.stringify(props.dataMaxima));
    // console.log('props.dataMaxima.x = '+JSON.stringify(props.dataMaxima.x));
    // console.log('maxX = '+JSON.stringify(maxX));
    // console.log('maxX.value = '+maxX.value);
    // console.log('maxY = '+JSON.stringify(maxY));
    // console.log('maxY.value = '+maxY.value);
    axis.value.primary.domain = ['0', dataMaximumX.value];
    axis.value.secondary.domain = [
      'dataMin + ' + dataMinimumY.value,
      dataMaximumY.value,
    ];
    // axis.value.primary.domain = ['0', '55'];
    // axis.value.secondary.domain = ['dataMin - 9', '55'];

    return { direction, margin, axis, marker, strokeWidth, plotDataVals };
  },
});
</script>

<style scoped>
g.layer-axis-x,
g.layer-axis-y {
  color: #c7cbdb;
}
</style>
